<se-fe-grid seFeGridOpts="loose">

  @if (isUpfrontAmount) {
<se-fe-grid-cell seFeGridOpts="grow@mobile">
    <span><strong [translate]="'PAYMENT_TERMS_SELECTOR.TITLES.upfront_payment'"></strong></span>
    @if (itemized && !termSelectionDisabled) {
<span seFePopoverTrigger="popoverPayment">
      <se-fe-popover
        seFePopoverName="popover">
        @if (dueInFull) {
<div
          class="popover-text"
          [innerHTML]="'PAYMENT_TERMS_SELECTOR.UPFRONT_PAYMENT.POPOVER.due_in_full' | translate">
        </div>
}
        @if (!dueInFull) {
<div
          class="popover-text"
          [innerHTML]="'PAYMENT_TERMS_SELECTOR.PLAN_PREVIEW.UPFRONT_PAYMENT.POPOVER.default' | translate">
        </div>
}
      </se-fe-popover>
    </span>
}
    <br>
    <small [translate]="'PAYMENT_TERMS_SELECTOR.PLAN_PREVIEW.due_upfront'"></small>
  </se-fe-grid-cell>
}

  @if (!isUpfrontAmount) {
<se-fe-grid-cell seFeGridOpts="grow@mobile">
    <se-fe-grid seFeGridOpts="middle">
      <strong
        [translate]="'PAYMENT_TERMS_SELECTOR.TITLES.installment'"
        [translateParams]="{ index: index }">
      </strong>
    </se-fe-grid>
    <small>
      {{ 'PAYMENT_TERMS_SELECTOR.due' | translate }}
      <span>{{ dueDate | date }}</span>
    </small>
  </se-fe-grid-cell>
}

  <se-fe-grid-cell seFeGridOpts="shrink@mobile">
    <strong>{{ amount | currency }}</strong>
  </se-fe-grid-cell>

</se-fe-grid>
